import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ComanServices from '../../services/ComanServices';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import BlogUpdate from './Update Model/StockUpdate';
import UserStatus from './TogelButton/UserStatus';

function TrandingStock() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  // Fetch blog data from the API when the component mounts
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await ComanServices.stock();
        console.log(response)
        setBlogs(response?.data || []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>
          Tranding Stock List <span className="badge bg-orange">{blogs?.length}</span>
        </h2>
        <div className="container-box-top-header-right">
          <a className="round-add-btn" href="/admin/add-stock">
            <img src="img/plus.svg" alt="Add Blog" />
          </a>
        </div>
      </div>
      <div className="container-box px-0 pt-2">
        <div className="container-box-inner">
          <table
            id="example"
            className="table table-striped"
            style={{ width: '100%' }}
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Stock</th>
                <th>Image</th>
                <th>Title</th>
                <th>Created Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {blogs?.length > 0 ? (
                blogs.map((blog, index) => (
                  <tr key={blog._id}>
                    <td>{index + 1}</td>
                    <td>{blog.stock}</td>
                    <td>
                      <div className="product-img">
                        <img src={process.env.REACT_APP_URL + blog?.images[0]} alt={blog.title} />
                      </div>
                    </td>
                    <td>{blog.title}</td>
                    <td>{new Date(blog.createdAt).toLocaleDateString()}</td>
                    <td className="status-toggle">
                      <div className="check-box">
                        <UserStatus user={blog} page="stock" />
                      </div>
                    </td>
                    <td>
                    <div className="action_toggle_outer">
                        <button
                          className="action_toggle"
                          onClick={() => toggleActionMenu(index)}
                        >
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === index && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li><button className="close_toggle" onClick={() => toggleActionMenu(null)}><i className="fa fa-close" /></button></li>
                              <li><button className="edit" onClick={() => handleEditDetails(blog)}>Edit</button></li>
                              <li><button className="reject" onClick={() => handleDelete(blog)}>Delete</button></li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Record Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <BlogUpdate notification={selectedEdit} closeModal={closeEditModal} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="stock" closeModal={closeDeleteModal}/>
        </Modal>
    </div>
  );
}

export default TrandingStock;
